import { TmApiValidationError } from '@/core/error/transport/tmApiValidationError'

export class TmNotEnoughBalanceError extends TmApiValidationError {
  public name = 'TmNotEnoughBalanceError'
}
